import loadResourceString from "@core/Util/resources";

import {
    sanitizeText,
    withNamedPermanentConnection,
    withPropertyBasedConnections
} from "./brick-initializer-helpers";

/**
 * Initialize the given AB brick
 * @param {JourneyBrick} brick
 */
const initialize = brick => {
    //Leftovers port for any records that could not be matched
    withNamedPermanentConnection(brick, {
        connectionIdProperty: 'leftoversConnectionId',
        configureConnection: connection => {
            connection.ui.tooltip.content = loadResourceString('JourneyComposer_ABTest_LeftoversConnection_TooltipContent')
        }
    });
    
    withPropertyBasedConnections(brick, {
        brickConfigProperty: 'routes',
        canDeleteConnection: connection => connection.id !== brick.config.leftoversConnectionId,
        onConnectionUpdated: (connection, route) => {
            const ui = connection.ui;
            
            ui.borderColor = route.color;
            ui.tooltip.title = `${route.percentage}%`;
            ui.tooltip.content = sanitizeText(route.description);
        }
    });
}

export {
    initialize
}